import * as React from 'react'
import * as styles from './shadow.access.styl'
import DataGrid from '@src/components/data.grid'
import Tile from '@src/components/common/tile'
import * as View from '@src/components/common/view.page'
import Tabs, { Tab } from '@src/components/common/material/tabs'
import {
  ExternalLists as ExternalListsActions,
  Autocomplete as AutocompleteActions
} from '@src/redux/actions'
import { useHistory, useLocation } from 'react-router-dom'
import { map } from 'lodash'
import type { ChangeShadowAccountNameOptions } from './models'
import {
  getShadowAccessGridConfig,
  TabLabels,
  ShadowAccessTabs,
  filterOptions
} from './configurations'
import * as CommonSelectors from '@src/selectors'
import * as Selectors from './selectors'
import { ShadowType } from '@src/endpoints/services/graphQueryMgr.service'
import { CSSSelector } from '@src/utils/css.selector.helper'
import { useDispatch, useSelector } from 'react-redux'
import { createAbortController } from '@src/components/abort.controller'
import QueryString from 'query-string'
import { defaultPageSize } from '@src/constants/grid'

interface Params {
  type?: ShadowType
}
interface OwnProps {
  selectedTab?: ShadowType
}
export type Props = OwnProps

export const ShadowAccessCSSSeletors = {
  contentPage: new CSSSelector('shadowAccessPage'),
  grid: new CSSSelector('shadowAccessDataGrid'),
  tabs: new CSSSelector('shadowAccesTabs')
}

const ShadowAccessPage: React.FC<Props> = React.memo((props: Props) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory<Params>()

  const lastUpdate = useSelector(CommonSelectors.getLastUpdate)
  const isLoading = useSelector(Selectors.getIsLoading)
  const lists = useSelector(Selectors.getShadowAccessLists)
  const resourceTypes = useSelector(CommonSelectors.getResourceTypes)

  const selectedTab = (QueryString.parse(location.search)?.type ||
    QueryString.parse(location?.location?.search)?.type ||
    props?.selectedTab) as ShadowType

  function loadData(tab: ShadowType) {
    dispatch(ExternalListsActions.getShadowAccessList({ tab }))
  }

  React.useEffect(() => {
    loadData(selectedTab)
  }, [selectedTab, props])

  function goToSearchResult(input: string) {
    dispatch(AutocompleteActions.saveSearchQuery(`${input}\n`))
  }

  function changeShadowAccountName(options: ChangeShadowAccountNameOptions) {
    dispatch(ExternalListsActions.setShadowAccountName(options))
  }

  function handleTabChange(value: ShadowType) {
    createAbortController({
      beforeClose: true
    })
    history.push(`?type=${value}`)
    loadData(value)
  }

  function renderTabs() {
    const tabs = map(ShadowAccessTabs, (tab, key) => (
      <Tab key={key} label={TabLabels.get(tab)} value={tab} badge={null} />
    ))

    return (
      <Tabs
        id={ShadowAccessCSSSeletors.tabs.value}
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
      >
        {tabs}
      </Tabs>
    )
  }

  return (
    <View.ContentPage
      noMargin
      noPadding
      id={ShadowAccessCSSSeletors.contentPage.value}
      className={styles.content}
    >
      <View.HeaderPage className={styles.header} lastUpdate={lastUpdate}>
        Shadow Access
      </View.HeaderPage>
      <div className={styles.tabs}>{renderTabs()}</div>
      <Tile className={styles.tabContent}>
        <DataGrid
          gridId={ShadowAccessCSSSeletors.grid.value}
          title={'Total Access'}
          showCount
          loading={isLoading}
          resourceTypes={resourceTypes}
          filterOptions={filterOptions}
          rowsPerPage={defaultPageSize}
          {...getShadowAccessGridConfig({
            lists,
            selectedTab,
            goToSearchResult,
            changeShadowAccountName
          })}
        />
      </Tile>
    </View.ContentPage>
  )
})

ShadowAccessPage.defaultProps = {
  selectedTab: ShadowType.SHADOW_UNKNOWN_ACCOUNT
}

export default ShadowAccessPage
